import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
class Usmeiben extends Component {
	state={
		youshi:[
			{
				name:'教育质量高，文凭含金量高',
				content:'上千所院校遍布全美，顶级的国际教育标准，世界排名第一、第二的院校都在美国。美国有世界上最先进的科技以及丰富的教育资源，并且拥有开放包容的文化氛围。名校众多：除了全球知名的常青藤盟校之外还有麻省理工、加州理工、斯坦福、加州公立系统下面的大学等等。应该说名校最多的就是美国，如果学生有名校情结，那去美国留学是很好的选择。',
			},
			{
				name:'教育资源丰富，资金充足',
				content:'全美4000余所高校，学校种类丰富，入学形式多样，满足各类学生的留学需求。美国政府极为重视教育，提供丰厚的教育研究经费。美国大学重视人才的吸引和投资，只要在学校表现出色，申请到奖助学金的机会非常大。',
			},
			{
				name:'专业全面，学制灵活',
				content:'美国是一个教育大国，文、理、工、商、艺术五大类的专业非常齐全。美国大部分4年制本科学时的大学，有1-2年的时间考虑专业方向，即使选定后不合适也可以转专业。专业转换灵活可以使得学生在学习过程中调整到更适合自己的专业。本科的时候转学都是比较容易的。并且可以跨专业申请的。工科之间本来就是相互交叉的，所以转起来比较容易。同时理科和工科的学生还可以转专业学习商科等。',
			},
			{
				name:'就业优势',
				content:'美国的校友资源丰富，再加上美国的内推文化，即当一个公司的员工成功推荐新员工入职，原来的员工是可以得到奖金的。因此，在美学生，除了广投简历，通过校友推荐入职也是一个强有力的渠道。\n' +
					'除此之外，中国学生毕业后有一年的OPT从学校过渡到职场。如果申请上STEM专业，则有3年的OPT可以在美工作，积累宝贵的工作经验，回国后市场认知度高，竞争力强，有更多的高薪机会。',
			},
			{
				name:'校园活动丰富，接触多样性文化',
				content:'美国的社会环境自由开放，多种文化民族相互碰撞，相互了解，在这里，你可以开展眼界，更容易接受不同于你的文化，增强包容性。美国大学国际留学生众多，校园活动丰富多彩“多元化”是美国大学非常重视的。',
			},
			{
				name:'提高学习自主性，学术资源丰富',
				content:'在美国，教授不会照本宣科一字一句地喂养式授课。教授更多地是引导学生自主学习。学生需要自己课前看阅读材料，自主完成基础知识的学习，在课上才能和教授进一步进行讨论。课堂外，美国大学的资源优势更为明显。美国越是优秀的大学越是能够提供丰富的学术资源，例如各类讲座、学术会议及交流活动等。',
			},
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/us01.png')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>美国简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								美国是一个比较强大，科技发达，人民幸福指数高的国家。 <br/>
								美国在近代史上占有的主导地位快速崛起，成为了相对年轻但又强大到不容置疑的一股力量。在世界格局中扮演重要角色，拥有实力世界第一的军队，生产的产品占据着世界市场的很大份额。</div>
							<img className={'img'} src={require('../../static/images/us02.png')} alt=""/>
						</div>
						<div className={'title'}>
							<span>美国留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>美国本科桂花季</span>
							<span className={'line'}/>
						</div>
						<div className={'usmodule'}>
							<div className={'fangan'}>
								<div className={'left'}>
									<div className={'usmoduleTitle'}>留学规划方案设计</div>
									<div className={'usmoduleText textJust'}>
										规划设计作为申请前期的准备阶段，应该是学生通过课外活动积累申请素材和提升综合竞争力的时期。这个阶段也是学生自我意识觉醒，成长蜕变，为更长远的未来做好准备的重要阶段。科学合理的规划设计不仅能帮助学生获得梦想的学校的青睐，也能够让他们在人生最宝贵的阶段锻炼终身受益的能力。根据学生目前情况，挖掘学生个人特色，引导学生参与设计自己的留学申请与规划活动，并选择自己喜欢的方式落地实践。
									</div>
								</div>
								<div className={'right'}>
									<img src={require('../../static/images/meiben01.jpg')} alt=""/>
								</div>
							</div>
							<div className={'steps'}>
								<div className={'stepsTitle'}>规划步骤</div>
								<div className={'stepsList'}>
									<div className={'stepItem'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/blue1.png')} alt=""/>
											<div className={'stepText textJust'}>签约后前期顾问，规划老师和文书老师同学生进行深度访谈，通过多维度观察，了解学生的性格特点、目标期望、兴趣爱好等申请背景素材（若学生家长有时间也可以邀请家长，一同会谈）；</div>
										</div>
									</div>
									<div className={'stepItem'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/red2.png')} alt=""/>
											<div className={'stepText textJust'}>学生完成16型人格测试和霍兰德职业测试，专业老师对测试结果进行解读和分析，根据自己的经验和学生特点推演出理想中的目标院校和匹配的专业；</div>
										</div>
									</div>
									<div className={'stepItem'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/red3.png')} alt=""/>
											<div className={'stepText textJust'}>规划老师根据访谈内容和测试结果产出【留学规划书】，规划书内容包含测试结果分析，职业介绍，目标院校介绍，目标专业介绍，课外活动设计（确定方向），标化成绩准备和技巧等内容。</div>
										</div>
									</div>
								</div>
								<div className={'fangan reversal'}>
									<div className={'left'}>
										<div className={'usmoduleTitle'}>留学规划落地执行</div>
										<div className={'usmoduleText textJust'}>
											留学规划书的目的和意义在于落地和执行。规划执行阶段决定了学生最终能否将优秀的申请材料呈现给招生官。在这个阶段，我们将致力于和学生一同克服可能面临的种种困难，让学生全身投入于自我实习过程，获得成长。
										</div>
									</div>
									<div className={'right'}>
										<img src={require('../../static/images/meiben02.jpg')} alt=""/>
									</div>
								</div>
								<div className={'stepsTitle'}>执行步骤</div>
								<div className={'stepsList'}>
									<div className={'stepItem stepItemF'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/red1.png')} alt=""/>
											<div className={'stepText textJust'}>GPA是美本申请中的重中之重，高中GPA的高低会直接影响学生美本申请时候的竞争力；顾问老师会实时关注学生在校期间的GPA情况，确认学生学习生活情况。及时发现问题，对接专业团队，进行家校联络，反馈学生情况，解决问题。</div>
										</div>
									</div>
									<div className={'stepItem stepItemF'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/blue2.png')} alt=""/>
											<div className={'stepText textJust'}>根据学生学习情况和成绩表现，由规划季老师制定出雅思/托福，SAT等各项标化考试全年考试时间轴督促并协助完成雅思/托福/SAT学习规划安排，将标化准备和在校学习统筹起来，帮助学生进行任务拆解和时间管理，督促学生提升。</div>
										</div>
									</div>
									<div className={'stepItem stepItemF'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/blue3.png')} alt=""/>
											<div className={'stepText textJust'}>由专业的规划老师通过活动口碑，活动方资质和服务质量筛选合适的活动并推送给学生。规划老师会同学生一起执行活动，在学生遇到困难时给予及时指导和帮助，同时对学生每月的执行进度进行反馈。为了活动方案能够根据不断变化的实际情况更好落地，我们将每个季度评估一次学生的整体情况，及时进行相应方案的调整</div>
										</div>
									</div>
									<div className={'stepItem stepItemF'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/red4.png')} alt=""/>
											<div className={'stepText textJust'}>在规划执行过程中，老师们将帮助学生定期沉淀既丰富又优质的课外活动资源和文书素材，为后续申请季文书写作打好基础。</div>
										</div>
									</div>
									<div className={'stepItem stepItemF'}>
										<div className={'stepItemWrap'}>
											<img className={'stepImg'} src={require('../../static/images/red5.png')} alt=""/>
											<div className={'stepText textJust'}>准备申请的过程，也是一个学生了解自己提高自己综合能力的过程。为了然学生更好适应美国大学的学习氛围和生活环境，老师们会给学生制定申请力课程，帮助学生在学习之余了解美国的地理环境风土人情，了解不同学校的特点。</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={'title'}>
							<span>美国本科申请季</span>
							<span className={'line'}/>
						</div>
						<div className={'usmodule'}>
							<div className={'fangan'}>
								<div className={'left'}>
									<div className={'usmoduleText textJust'}>
										申请操作阶段是整个申请过程中最重要的阶段。在申请季开始时，我们会根据学生情况制定申请季时间表，包括申请材料准备时间表、申请文书操作时间表帮助学生更有条理地完成申请材料的准备和递交。
									</div>
								</div>
								<div className={'right'}>
									<img src={require('../../static/images/meiben03.jpg')} alt=""/>
								</div>
							</div>
							<div className={'usShenqing'}>
								<div className={'usShenqingItem'}>
									<div className={'usShenqingTitle'}>
										<div className={'usShenqingTitleBlock'}>制定申请策略</div>
									</div>
									<p className={'textJust'}><span>●</span> 根据学校当年的申请形式制定不同的ED/EA/RD/加州学校申请策略。</p>
									<p className={'textJust'}><span>●</span>选校建议：结合申请力课程中学校调研的内容，我们将为学生提供充足的院校信息，和学生一起调研选校，分析选校策略，最终完成选校方案。</p>
									<p className={'textJust'}><span>●</span>专业建议：结合申请力课程中的专业调研内容，我们将为学生提供全面的专业信息，对学生有意向的专业进行调研和指导，协助学生确定专业选择。</p>
								</div>
								<div className={'usShenqingItem'}>
									<div className={'usShenqingTitle'}>
										<div className={'usShenqingTitleBlock'}>申请材料准备</div>
									</div>
									<p className={'textJust'}><span>●</span> 帮助学生提炼课外活动的主线和辅线，修改课外活动列表和简历，帮助挖掘推荐信素材，知道开具成绩单和资金证明等相关材料。</p>
								</div>
								<div className={'usShenqingItem'}>
									<div className={'usShenqingTitle'}>
										<div className={'usShenqingTitleBlock'}>网申系统填写</div>
									</div>
									<p className={'textJust'}><span>●</span> 根据学校要求，注册申请账户，并指导学生完成网上填写，同时进行反复检查和审核。</p>
									<p className={'textJust'}><span>●</span>完成申请费用缴纳，托福，SAT，AP等送分。</p>
									<p className={'textJust'}><span>●</span>实时关注学校官网内容，查看是否需要补交材料。</p>
								</div>
								<div className={'usShenqingItem'}>
									<div className={'usShenqingTitle'}>
										<div className={'usShenqingTitleBlock'}>面试申请指导</div>
									</div>
									<div className={'textJust'}>
										通过面试指导课程提升学生的整体面试能力，并教会学生做collegeresearch的方法。
										根据不同学校的面试要求，对每所欲面试学校进行一对一的面试培训。
									</div>
									<p className={'textJust'}><span>●</span>校友面试：由分布在与学生同一个地区的校友担任面试官对申请此大学的学生进行面试（一般是所有材料提交之后）。</p>
									<p className={'textJust'}><span>●</span>学校招生官面试：一般情况想很少会有招生官面试，只有在特殊情况需要学生进行招生官面试（比如维克森林）。</p>
								</div>
								<div className={'usShenqingItem'}>
									<div className={'usShenqingTitle'}>
										<div className={'usShenqingTitleBlock'}>申请跟进</div>
									</div>
									<p className={'textJust'}><span>●</span>同申请学校保持密切联系，了解学生的录取状态。。</p>
									<p className={'textJust'}><span>●</span>defer/waitinglist等情况的策略应对。提供详细的录取学校介绍，给出选校建议。。</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Usmeiben